import React, { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";

export default function PublicRoute({ children }) {
  const [loading, setLoading] = useState(true);
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  useEffect(() => {
    fetch(`${process.env.REACT_APP_BASE_URL}api/auth/customer-profile`, {
      credentials: "include",
    })
      .then((res) => res.json())
      .then((data) => {
        setIsAuthenticated(!!data.CP_Emailaddress);
        setLoading(false);
      })
      .catch(() => {
        setIsAuthenticated(false);
        setLoading(false);
      });
  }, []);

  if (loading) return <p>Loading...</p>;

  // If already logged in, redirect away from login page
  if (isAuthenticated) {
    return <Navigate to="/customer-profile" replace />;
  }

  return children;
}
